import Vue from 'vue'
import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
Vue.use(VueSidebarMenu)
export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  props: {
    relative: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      menu: [
        {
          title: 'Dashboard',
          icon: 'fa fa-dashboard',
          href: '/dashboard'
        },
        {
          title: 'Calendar',
          icon: 'fa fa-calendar',
          href: '/calendar'
        },
        // {
        //   title: 'Explore Professional',
        //   icon: 'fa fa-users',
        //   href: '/explore_Professional'
        // },
        {
          title: 'Jobs',
          icon: 'fa fa-tasks',
          child: [
          // {
            // header: false,
            // title: 'Mini Jobs',
            // child: [
            {
              href: '/open_jobs',
              title: 'Open Jobs'
            },
            {
              href: '/upcoming_jobs',
              title: 'Accepted Jobs'
            },
            {
              href: '/ongoing_jobs',
              title: 'Ongoing Jobs'
            },
            {
              href: '/completed_jobs',
              title: 'Completed Jobs'
            },
            {
              href: '/cancelled_jobs',
              title: 'Cancelled Jobs'
            }
            // {
            //   href: '/all_jobs',
            //   title: 'All Jobs'
            // }
            // ]

          // }
          // {
          //   href: '/temporary_jobs',
          //   title: 'Temporary Jobs'
          // }
          ]
        },
        {
          icon: 'fa fa-check',
          href: '/time_approval_jobs',
          title: 'Shift Logs'
        },
        // {
        //   title: 'Settings',
        //   icon: 'fa fa-cog',
        //   child: [
        //     {
        //       href: '/setting/profile',
        //       title: 'Your Profile'
        //     }
        //     // {
        //     //   href: '/setting/organization_profile',
        //     //   title: 'ORG Profile'
        //     // },
        //     // {
        //     //   href: '/setting/companies',
        //     //   title: 'Companies'
        //     // },
        //     // {
        //     //   href: '/setting/companies',
        //     //   title: 'Departments'
        //     // },
        //     // {
        //     //   href: '/setting/branch',
        //     //   title: 'Branches'
        //     // }
        //   ]
        // },
        {
          title: 'Users',
          icon: 'fa fa-users',
          child: [
            {
              href: '/user/user_list',
              title: 'User List'
            },
            {
              href: '/user/user_permission',
              title: 'Permissions'
            }
          ]
        },
        {
          title: 'Reports',
          icon: 'fa fa-bug',
          child: [
            {
              href: '/open_jobs_report',
              title: 'Open Jobs'
            },
            {
              href: '/upcoming_jobs_report',
              title: 'Accepted Jobs'
            },
            {
              href: '/ongoing_jobs_report',
              title: 'Ongoing Jobs'
            },
            {
              href: '/completed_jobs_report',
              title: 'Completed Jobs'
            },
            {
              href: '/cancelled_jobs_report',
              title: 'Cancelled Jobs'
            },
            {
              href: '/time_approval_reports',
              title: 'Time Approval'
            }
          ]
        }
        // {
        //   title: 'Logout',
        //   icon: 'fa fa-sign-out',
        //   href: '/'
        // }
      ]
    }
  },
  components: {},
  computed: {},
  methods: {}
}
